import React from "react"
import { useTranslation } from "react-i18next"
import {
  withFormik,
  FormikProps,
  FormikErrors,
  Form,
  Field,
  FieldProps,
} from "formik"
import { Grid } from "@mui/material"

import i18n from "config/i18n"
import Input from "components/ui/Input"
import { Submit } from "components/Subscription/Modal/Create/elements"
import { ZlickAuthRequestValues } from "types"

interface FormProps {
  initialValues: {
    subscription_id: string
    phone: string
  }
  onSubmit: (values: ZlickAuthRequestValues) => void
}

type Props = FormikProps<ZlickAuthRequestValues> & FormProps

const SubscriptionMobilePaymentForm = ({ errors, isSubmitting }: Props) => {
  const { t } = useTranslation()

  return (
    <Form>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field name="phone">
            {({ field }: FieldProps) => (
              <Input
                fullWidth
                label={t("features.subscription.form.phone")}
                helperText={errors.phone}
                disabled={isSubmitting}
                {...field}
              />
            )}
          </Field>
        </Grid>
        <Submit type="submit" disabled={isSubmitting}>
          {t("features.subscription.form.submit")}
        </Submit>
      </Grid>
    </Form>
  )
}

const SubscriptionMobilePaymentFormWithFormik = withFormik<
  FormProps,
  ZlickAuthRequestValues
>({
  enableReinitialize: true,
  mapPropsToValues: ({ initialValues }) => initialValues,
  handleSubmit: (values, { props: { onSubmit } }) => onSubmit(values),
  validate: (values: ZlickAuthRequestValues) => {
    const errors: FormikErrors<ZlickAuthRequestValues> = {}

    const { phone } = values

    if (!phone) {
      errors.phone = i18n.t("validation.field.required", {
        field: i18n.t("features.subscription.form.phone"),
      })
    }

    return errors
  },
})(SubscriptionMobilePaymentForm)

export default SubscriptionMobilePaymentFormWithFormik
